<template>
  <a-row class="not-resize-for-mobile">
    <a-col :sm="24" :md="24" :lg="24" :xl="14" :xxl="14">
      <a-card :bordered="false">
        <!-- 検索エリア -->
        <div class="table-page-search-wrapper">
          <!-- 検索エリア -->
          <a-form-model layout="inline" @keyup.enter.native="searchQuery(false, false)">
            <a-row :gutter="24">
              <a-col :sm="24" :md="10" :lg="8" :xl="12" :xxl="9">
                <!-- 施設種類情報画面の検索をクリックの場合、検索処理を行う
                     施設種類情報の「検索」をクリックする -->
                <a-form-model-item :label="this.$t('disp.facilityTypeName')" :labelCol="{ span: 6 }">
                  <a-input
                    :placeholder="this.$t('disp.facilityTypeSearch')"
                    v-model="queryParam.facilityTypeName"
                    :maxLength="90"
                  ></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :sm="24" :md="14" :lg="16" :xl="12" :xxl="15">
                <!-- 一覧.施設種類名称：施設種類情報.施設種類名称 
                         一覧.备注：施設種類情報.备注 
                         一覧.ソート順：施設種類情報.ソート順 
                         一覧.施設種類ID（隠し）：施設種類情報.PK_ID -->
                <a-button type="primary" @click="searchQuery(false, false)" icon="search">{{
                  $t('disp.btn.search')
                }}</a-button>
                <!-- 施設種類情報エリアの検索条件を初期化する -->
                <a-button @click="searchReset" icon="stop">{{ $t('disp.btn.reset') }}</a-button>
              </a-col>
            </a-row>
          </a-form-model>
        </div>
        <!-- ボタン -->
        <div class="table-operator">
          <!-- 追加 
               施設種類情報の「追加」ボタンをクリックする -->
          <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('disp.btn.add') }}</a-button>
          <template v-if="$getLoginUser().editableFlag == '1'">
            <a-divider type="vertical"></a-divider>
            <!-- 同步会议预约信息到皓丽会议平板管理系统按钮 -->
            <a-button @click="handleSyncToHorion" type="primary" :disabled="syncing">同步会议室预约信息到皓丽</a-button>
          </template>
        </div>
        <!-- テーブル 
                 施設種類情報一覧のラジオボタンをクリックする 
                 一覧.施設名称：施設情報.施設名称 
                 一覧.备注：施設情報.备注 
                 一覧.ソート順：施設情報.ソート順
                 dataSource     
                 rowKey   
                 pagination  
                 loading  
                -->
        <div>
          <a-table
            ref="table"
            tableLayout="auto"
            class="action font-size-13"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, type: 'radio' }"
            @change="handleTableChange"
          >
            <!-- 使用部门 -->
            <div slot="facilityTypeDepartNames" slot-scope="text, record" style="line-height: 1.5; font-size: 12px">
              <div v-for="(sysGroup, idx) in record.sysGroups" :key="idx" style="display: flex">
                <div style="min-width: fit-content">{{ sysGroup.systemName }}：</div>
                <div style="color: var(--color-grey)">{{ sysGroup.departsText }}</div>
              </div>
            </div>
            <!-- slot 
                     施設種類情報一覧の「編集」をクリックする
                     施設種類情報一覧の「削除」をクリックする
                     内容：削除します、よろしいでしょうか？
                     2)削除成功後、メッセージを表示する。
                     内容：削除しました。 -->
            <div slot="action" slot-scope="text, record" style="white-space: nowrap">
              <a @click="handleEdit(record)">{{ $t('disp.btn.edit') }}</a>
              <a-divider type="vertical" />
              <a-popconfirm :title="$t('msg.confirm.delete')" @confirm="() => handleDelete(record.id)">
                <a>{{ $t('disp.btn.delete') }}</a>
              </a-popconfirm>
            </div>
          </a-table>
        </div>
        <!--  
             ポップアップ画面を開く 
             ポップアップ画面にデータ更新成功後、ポップアップ画面を閉じる、メッセージを表示する。 -->
        <facility-type-modal ref="modalForm" @emit="modalFormOk"></facility-type-modal>
      </a-card>
    </a-col>
    <a-col :sm="24" :md="24" :lg="24" :xl="10" :xxl="10">
      <!--  施設情報tab -->
      <a-tabs defaultActiveKey="1">
        <a-tab-pane :tab="this.$t('disp.facilityInfo')" key="1" :forceRender="true">
          <facility-manage-info ref="FacilityManageInfo"></facility-manage-info>
        </a-tab-pane>
      </a-tabs>
    </a-col>
  </a-row>
</template>
<script>
import { tableMixin } from '@/mixins/tableMixin'
import { deleteAction, postAction, getAction } from '@/api/manage'
import { filterObj } from '@/utils/util'
import FacilityTypeModal from './modules/FacilityTypeModal'
import moment from 'moment'
import FacilityManageInfo from './modules/FacilityManageInfo'
export default {
  name: 'FacilitiesManage',
  mixins: [tableMixin],
  components: {
    // FacilityTypeModal
    FacilityTypeModal,
    // FacilityManageInfo
    FacilityManageInfo,
    // moment
    moment,
  },
  mounted() {
    this.forceClear = true
  },
  data() {
    return {
      model: {},
      // 同步中
      syncing: false,
      // 施設種別ID
      currentFacilityTypeId: '',
      columns: [
        {
          // 施設種別名称
          title: this.$t('disp.facilityTypeName'),
          dataIndex: 'facilityTypeName',
        },
        {
          // 使用部门
          title: this.$t('disp.facilityTypeDeparts'),
          dataIndex: 'facilityTypeDepartNames',
          scopedSlots: { customRender: 'facilityTypeDepartNames' },
        },
        {
          // 备注
          title: this.$t('disp.note'),
          dataIndex: 'memo',
        },
        {
          // ソート順
          title: this.$t('disp.sort'),
          dataIndex: 'sortOrder',
          align: 'center',
          width: '100px',
        },
        {
          // 操作
          title: this.$t('disp.operation'),
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        // 施設種別リストを取得
        list: '/kgms/k04/FacilitiesManage/listByName',
        // 施設削除
        delete: '/kgms/k04/FacilitiesManage/deleteFacilityType',
        // 同步会议预约信息到皓丽会议平板管理系统
        syncMeetingDataToHorion: '/kgms/k04/FacilitiesManage/syncMeetingDataToHorion',
      },
    }
  },
  methods: {
    callbackAfterSearchQuery(records) {
      // 使用部门按系统分组
      records.forEach((item) => {
        if (item.facilityTypeDeparts && item.facilityTypeDeparts.length > 0) {
          let sysGroup = XEUtils.groupBy(item.facilityTypeDeparts, 'systemCode')
          let arr = []
          for (let k in sysGroup) {
            arr.push({
              systemName: sysGroup[k][0].systemName,
              departsText: XEUtils.map(sysGroup[k], (depart) => depart.departName).join('、'),
            })
          }
          item.sysGroups = arr
        } else {
          item.sysGroups = []
        }
      })

      this.dataSource = records
    },
    /**
     * 施設種別変更
     */
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectionRows = selectionRows
      // 子画面に施設情報の施設名
      this.$refs.FacilityManageInfo.queryParam.facilityName = ''
      // 子画面onClearSelectedを呼び出す
      this.$refs.FacilityManageInfo.onClearSelected()
      // 子画面オープン
      this.$refs.FacilityManageInfo.open(selectionRows[0])
    },
    // 同步会议预约信息到皓丽会议平板管理系统（注意：请在会议室预约使用较少时同步）
    handleSyncToHorion() {
      let that = this

      this.$confirm({
        title: that.$t('disp.warn'),
        content: '请确定是否同步会议预约信息到皓丽会议平板管理系统（建议在会议室预约功能使用较少时同步）。',
        centered: true,
        onOk() {
          if (that.syncing) {
            return
          } else {
            that.syncing = true
          }

          getAction(that.url.syncMeetingDataToHorion)
            .then((res) => {
              if (res.success) {
                that.$message.success('同步成功')
              }
            })
            .finally(() => {
              that.syncing = false
            })
        },
        onCancel() {},
      })
    },
  },
  watch: {
    // 選択されたの施設種別ID
    selectedRowKeys: function (e) {
      if (this.selectedRowKeys.length == 0) {
        this.$refs.FacilityManageInfo.currentFacilityTypeId = ''
        this.$refs.FacilityManageInfo.queryParam = {}
      }
    },
  },
}
</script>
<style scoped></style>
